import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Calendar, Video, Star } from 'lucide-react';
export function OfferStack() {
  // IDs de Variantes de Shopify Actualizados y Verificados
  const ID_TOOLKIT = '43864513380440';
  const ID_REELS = '43864611520600';
  const ID_CALENDAR = '43864790302808';

  // Enlaces de Checkout Directos (Permalinks)
  const links = {
    toolkit: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1`,
    toolkitReels: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_REELS}:1`,
    toolkitCalendar: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_CALENDAR}:1`,
    vipAll: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_REELS}:1,${ID_CALENDAR}:1`
  };
  return <section id="comprar" className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden w-full relative z-20" data-id="element-136">
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-green-500/10 rounded-[40px] blur-[100px]" data-id="element-137" />

      <div className="relative bg-[#050505] border border-white/10 shadow-2xl rounded-[40px] p-6 md:p-14 overflow-hidden" data-id="element-138">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-139" />

        <div className="text-center mb-12" data-id="element-140">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-141">
            Elige tu <span className="text-cyan-400" data-id="element-142">Nivel de Control</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-143">
            Selecciona el sistema que mejor se adapte a tu negocio. Pago único, el archivo es tuyo de por vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-144">
          
          {/* OPCIÓN 1: BÁSICO ($24.99) */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-145">
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-146">Control Básico</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-147">Lo esencial para no perder dinero por la inflación.</p>
            <div className="mb-6" data-id="element-148">
              <span className="text-4xl font-black text-white" data-id="element-149">$24.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-150">
              <li className="flex items-start gap-2" data-id="element-151">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-152" /> 
                <span className="font-bold text-white" data-id="element-153">Sistema Masterkit (Excel)</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-154">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-155" /> 
                <span data-id="element-156">Control de Inventario y Precios Automáticos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-157">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-158" /> 
                <span data-id="element-159">BONO: 100 Plantillas Canva</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-160">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-161" /> 
                <span data-id="element-162">BONO: Scripts de Ventas WhatsApp</span>
              </li>
            </ul>
            <a href={links.toolkit} className="w-full py-3 px-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-xl text-center transition-all" data-id="element-163">
              Comprar Básico
            </a>
          </div>

          {/* OPCIÓN 2: VIRAL ($39.99) */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-164">
            <div className="flex items-center gap-2 text-green-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-165">
              <Video className="w-4 h-4" data-id="element-166" /> Atrae más clientes
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-167">Control + Viral</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-168">El sistema Excel + Guiones para videos cortos.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-169">
              <span className="text-4xl font-black text-white" data-id="element-170">$39.99</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-171">$54.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-172">
              <li className="flex items-start gap-2" data-id="element-173">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-174" /> 
                <span className="font-bold text-white" data-id="element-175">Todo lo del Básico</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-176">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-177" /> 
                <div data-id="element-178">
                  <span className="block font-bold text-white" data-id="element-179">Kit 50 Reels Virales</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-180">Estructuras probadas para atraer gente a tu local.</span>
                </div>
              </li>
            </ul>
            <a href={links.toolkitReels} className="w-full py-3 px-4 bg-green-500/20 hover:bg-green-500/30 text-green-400 font-bold rounded-xl text-center transition-all" data-id="element-181">
              Llevar Paquete Viral
            </a>
          </div>

          {/* OPCIÓN 3: ESTRATEGA ($47.99) */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-182">
            <div className="flex items-center gap-2 text-cyan-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-183">
              <Calendar className="w-4 h-4" data-id="element-184" /> Marketing Anual
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-185">Control + Estratega</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-186">El sistema Excel + Calendario de contenido.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-187">
              <span className="text-4xl font-black text-white" data-id="element-188">$47.99</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-189">$64.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-190">
              <li className="flex items-start gap-2" data-id="element-191">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-192" /> 
                <span className="font-bold text-white" data-id="element-193">Todo lo del Básico</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-194">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-195" /> 
                <div data-id="element-196">
                  <span className="block font-bold text-white" data-id="element-197">Calendario 365 Días</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-198">El mapa exacto de qué publicar cada día para no estancarte.</span>
                </div>
              </li>
            </ul>
            <a href={links.toolkitCalendar} className="w-full py-3 px-4 bg-cyan-500/20 hover:bg-cyan-500/30 text-cyan-400 font-bold rounded-xl text-center transition-all" data-id="element-199">
              Llevar Paquete Estratega
            </a>
          </div>

          {/* OPCIÓN 4: VIP ($62.99) */}
          <motion.div whileHover={{
          y: -5
        }} className="flex flex-col bg-gradient-to-b from-green-500/10 to-cyan-500/10 border-2 border-cyan-400 rounded-3xl p-6 relative shadow-[0_0_30px_rgba(34,197,94,0.15)]" data-id="element-200">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-green-400 to-cyan-400 text-black font-black text-xs uppercase tracking-widest py-1 px-4 rounded-full flex items-center gap-1 shadow-lg" data-id="element-201">
              <Star className="w-3 h-3" data-id="element-202" /> Recomendado
            </div>
            <h3 className="text-xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 mb-2 mt-2" data-id="element-203">Paquete VIP Total</h3>
            <p className="text-gray-300 text-sm mb-4 min-h-[40px]" data-id="element-204">Sana tus finanzas y explota tus ventas.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-205">
              <span className="text-4xl font-black text-white" data-id="element-206">$62.99</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-207">$94.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-white font-medium" data-id="element-208">
              <li className="flex items-start gap-2" data-id="element-209">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-210" /> 
                <span className="font-bold" data-id="element-211">Sistema Excel + Todos los Bonos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-212">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-213" /> 
                <span className="block" data-id="element-214">Kit 50 Reels Virales</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-215">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-216" /> 
                <span className="block" data-id="element-217">Calendario 365 Días</span>
              </li>
              <li className="flex items-start gap-2 mt-4 text-cyan-300 text-xs italic" data-id="element-218">
                Ahorras $32.00 dólares adquiriendo el sistema completo.
              </li>
            </ul>
            <a href={links.vipAll} className="w-full py-3 px-4 bg-gradient-to-r from-green-500 to-cyan-500 hover:from-green-400 hover:to-cyan-400 text-white font-black uppercase tracking-wide rounded-xl text-center transition-all shadow-lg flex items-center justify-center gap-2" data-id="element-219">
              ¡Quiero Todo!
            </a>
          </motion.div>

        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-500 text-xs font-bold uppercase tracking-widest border-t border-white/10 pt-8" data-id="element-220">
          <span className="flex items-center gap-2" data-id="element-221">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-222" /> Pago Seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-223">Pago Móvil / Binance / Tarjetas</span>
          <span className="flex items-center gap-2" data-id="element-224">Entrega Inmediata</span>
        </div>
      </div>
    </section>;
}